import { render, staticRenderFns } from "./t-tab.vue?vue&type=template&id=92ba3b0e"
import script from "./t-tab.vue?vue&type=script&lang=js"
export * from "./t-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports